export default class Gif {
  constructor({ previewUrl, shareUrl, id }) {
    this.previewUrl = previewUrl;
    this.shareUrl = shareUrl;
    this.id = id;
  }

  static fromTenor(res) {
    const media = res.media[0];
    const previewUrl = media.tinygif.url;
    const shareUrl = media.gif.url;
    const { id } = res;
    return new Gif({ previewUrl, shareUrl, id });
  }
}
